import React, { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import LayoutCms from "@/theme/layout-cms";
import Icon from "@/theme/vectors/bundle";
import { useAuth } from "@/hooks/useAuth";
import { useTranslation } from "@/hooks/useTranslation";
import DataTablesPanel from "@/components/database/DataTablesPanel";
import SqlQueryPanel from "@/components/database/SqlQueryPanel";

// TabPanel component to handle tab content
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`database-tabpanel-${index}`}
            aria-labelledby={`database-tab-${index}`}
            {...other}
            style={{ width: '100%' }}
        >
            {value === index && (
                <Box sx={{ pt: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const DatabasePage = () => {
    const { user, userInfoLoaded } = useAuth();
    const { t } = useTranslation();
    
    // Tab state
    const [tabValue, setTabValue] = useState(0);
    
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <LayoutCms>
            <Box sx={{ p: 3 }}>
                <Typography variant="h4" sx={{ mb: 3 }}>
                    {t('database.title')}
                </Typography>
                
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs 
                        value={tabValue} 
                        onChange={handleTabChange} 
                        aria-label="database tabs"
                    >
                        <Tab 
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Icon name="fileContent" size={20} />
                                    <span>{t('database.tabs.dataTables')}</span>
                                </Box>
                            }
                        />
                        <Tab 
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Icon name="cogwheel" size={20} />
                                    <span>{t('database.tabs.sqlQuery')}</span>
                                </Box>
                            }
                        />
                    </Tabs>
                </Box>
                
                {/* Data Tables Tab */}
                <TabPanel value={tabValue} index={0}>
                    <DataTablesPanel />
                </TabPanel>
                
                {/* SQL Query Tab */}
                <TabPanel value={tabValue} index={1}>
                    <SqlQueryPanel />
                </TabPanel>
            </Box>
        </LayoutCms>
    );
};

export default DatabasePage;